interface ValidateNumericalOptions {
  readonly customError?: string;
}

export const validateNumerical = (value: string, translate: CallableFunction, options: ValidateNumericalOptions = {}) => {
  const { customError } = options;

  if (!(/^[0-9]+$/.test(value))) {
    return customError || translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideOnlyNumbers");
  }

  return undefined;
};
